import React from 'react';
import "react-alice-carousel/lib/alice-carousel.css";
import {jssPreset, StylesProvider} from '@mui/styles';
import {StyledEngineProvider, ThemeProvider} from "@mui/material/styles";
import CssBaseline from '@mui/material/CssBaseline';

import CustomTheme from "./assets/CustomTheme";
import './assets/fonts/css/fontiran.css'

import {create} from "jss";
import rtl from "jss-rtl";

import {StaticPageComponent} from "./components/StaticPageComponent";

import {BrowserRouter, Route, Routes} from "react-router-dom";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";

import {aboutUsContent, privacyPolicyContent} from "./Const";
import {TransactionComponent} from "./components/TransactionComponent";
import {OrderComponent} from "./components/OrderComponent";
import ProductProvider from "./components/ProductProvider";
import PaymentProvider from "./components/PaymentProvider";

import {ProfileComponent} from "./components/ProfileComponent";
import AllProductProvider from "./components/AllProductProvider";
import AllMarketProvider from "./components/AllMarketProvider";
import {OfferComponent} from "./components/OfferComponent";

import ProductListProvider from "./components/ProductListProvider";
import GlobalProvider from "./components/GlobalProvider";
import {OtpMessengerComponent} from "./components/messenger/OtpMessengerComponent";
import {LoginMessengerComponent} from "./components/messenger/LoginMessengerComponent";
import {LotteryComponent} from "./components/LotteryComponent";
import {WinnerComponent} from "./components/WinnerComponent";
import {Navigate} from "react-router";
import LoginComponent from "./components/LoginComponent";
import OtpComponent from "./components/OtpComponent";
import MessengerMain from "./components/messenger/MessengerMain";
import ChatProvider from "./components/messenger/ChatProvider";
import SearchComponent from "./components/SearchComponent";
import MapWithMarketSync from './components/MapWithMarketSync';
import 'leaflet/dist/leaflet.css';
import {ProductUnitComponentWrapper} from "./components/ProductUnitComponentWrapper";
import ToolbarComponent from "./components/ToolbarComponent";

const jss = create({
    plugins: [...jssPreset().plugins, rtl()],
});


function App() {

    const isLoggedIn = localStorage.getItem('pwa_token') !== null

    return (
        <StyledEngineProvider injectFirst>
            <StylesProvider jss={jss}>
                <ThemeProvider theme={CustomTheme}>
                    <CssBaseline/> {/* ✅ Resets margin/padding of html/body */}
                    <BrowserRouter>

                        <Routes>

                            <Route path="/verify" element={
                                <OtpComponent/>
                            }/>
                            <Route path="/login" element={
                                <LoginComponent/>
                            }/>

                            <Route path="/messenger/verify" element={
                                <OtpMessengerComponent/>
                            }/>
                            <Route path="/messenger/login" element={
                                <LoginMessengerComponent/>
                            }/>

                            <Route path="/markets" element={
                                <ToolbarComponent/>
                            }/>

                            <Route path="/privacy-policy" element={
                                <StaticPageComponent title={"قوانین و مقررات"} content={privacyPolicyContent}
                                                     icon={<PrivacyTipOutlinedIcon/>}/>}/>
                            <Route path="/about-us" element={
                                <StaticPageComponent title={"درباره ما"} content={aboutUsContent}
                                                     icon={<ReduceCapacityOutlinedIcon/>}/>
                            }/>
                            <Route path="/transaction" element={
                                isLoggedIn ? <TransactionComponent/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/lottery" element={
                                isLoggedIn ? <LotteryComponent/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/winners" element={
                                isLoggedIn ? <WinnerComponent/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/order" element={
                                isLoggedIn ? <ProductUnitComponentWrapper route={"order"}/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/market/*" element={
                                <ProductListProvider/>
                            }/>

                            <Route path="/product/*" element={
                                <ProductProvider/>
                            }/>

                            <Route path="/cardShop" element={
                                isLoggedIn ? <ProductUnitComponentWrapper route={"cardShop"}/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/payment-callback" element={
                                isLoggedIn ? <PaymentProvider/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/profile" element={
                                isLoggedIn ? <ProfileComponent/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/messenger/chat" element={
                                isLoggedIn ? <ChatProvider/> : <Navigate to='/verify'/>
                            }/>
                            {/*   <Route path="/messenger/profile" element={
                                isLoggedIn ? <GroupListComponent/> : <Navigate to='/verify'/>
                            }/>*/}

                            <Route path="/messenger/:tab" element={<MessengerMain/>}/>
                            {/*  <Route path="/messenger/dialogs" element={
                                isLoggedIn ? <DialogComponent/> : <Navigate to='/verify'/>
                            }/>



                            <Route path="/messenger/groups" element={
                                isLoggedIn ? <GroupListComponent/> : <Navigate to='/verify'/>
                            }/>

                            <Route path="/messenger/channels" element={
                                isLoggedIn ? <ChannelListComponent/> : <Navigate to='/verify'/>
                            }/>



                            <Route path="/messenger/contacts" element={
                                isLoggedIn ? <ContactListComponent/> : <Navigate to='/verify'/>
                            }/>
    */}
                            <Route path="/search" element={
                                <ProductUnitComponentWrapper route={"search"}/>
                            }/>

                            <Route path="/" element={
                                <OfferComponent/>
                            }/>

                            <Route path="/market-map" element={
                                <MapWithMarketSync/>
                            }/>

                            <Route path="/product-list/*" element={
                                <AllProductProvider/>
                            }/>

                            <Route path="/market-list/*" element={
                                <AllMarketProvider/>
                            }/>

                            <Route path="/*" element={
                                <GlobalProvider/>
                            }/>
                        </Routes>

                    </BrowserRouter>
                </ThemeProvider>
            </StylesProvider>
        </StyledEngineProvider>
    );

}


export default App;







